import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Problem`}</h2>
    <ul>
      <li parentName="ul">{`Write a pod definition named `}<inlineCode parentName="li">{`yoda-service-pod.yml`}</inlineCode>{` Then create a pod in the cluster using this definition to make sure it works.`}</li>
    </ul>
    <p>{`The specificationsof this pod are as follows:`}</p>
    <ul>
      <li parentName="ul">{`Use the `}<inlineCode parentName="li">{`bitnami/nginx`}</inlineCode>{` container image.`}</li>
      <li parentName="ul">{`The container needs a containerPort of `}<inlineCode parentName="li">{`80`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Set the command to run as `}<inlineCode parentName="li">{`nginx`}</inlineCode></li>
      <li parentName="ul">{`Pass in the `}<inlineCode parentName="li">{`-g daemon off; -q`}</inlineCode>{` args to run nginx in quiet mode.`}</li>
      <li parentName="ul">{`Create the pod in the `}<inlineCode parentName="li">{`web`}</inlineCode>{` namespace.`}</li>
    </ul>
    <h2>{`Verification`}</h2>
    <p>{`When you have completed this lab, use the following commands to validate your solution. The ‘get pods’ command will `}</p>
    <p><inlineCode parentName="p">{`kubectl get pods -n web`}</inlineCode>{`
`}<inlineCode parentName="p">{`kubectl describe pod nginx -n web`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      